<template>
  <v-menu
    :value="value"
    :position-x="x"
    :position-y="y"
    transition="slide-y-transition"
    zIndex="9999"
    absolute
    @input="close"
  >
    <v-list dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="item.click"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
        <v-list-item-icon>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { flyToCenter, selectPoints, ruler, square } from '../../plugins/map-context-menu'
import { mdiImageFilterCenterFocus, mdiRuler, mdiRulerSquare, mdiSelect } from '@mdi/js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    map: {
      type: Object,
      default: () => null
    },
    x: {
      type: Number,
      default: () => 0
    },
    y: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      menuOptions: {
        x: -128,
        y: 128
      },
      items: [
        {
          title: 'Center',
          icon: mdiImageFilterCenterFocus,
          click: flyToCenter.bind(this)
        },
        {
          title: 'Select points',
          icon: mdiSelect,
          click: selectPoints.bind(this)
        },
        {
          title: 'Ruler',
          icon: mdiRuler,
          click: ruler.bind(this)
        },
        {
          title: 'Square',
          icon: mdiRulerSquare,
          click: square.bind(this)
        }
      ],
    }
  },
  methods: {
    close (event) {
      this.$emit('input', event)
    }
  }
}
</script>